import { useAuth } from '../auth/AuthProvider';
import logo from '../assets/tww-logo.svg';

/** Nutzer ohne Rolle: Hinweis auf fehlende Freischaltung */
export function WelcomePage() {
  const { me, logout } = useAuth();
  return (
    <div className="login">
      <div className="card">
        <div className="brand login-logo">
          <img src={logo} alt="Trinkwasserwald e.V." />
        </div>
        <h1 style={{ fontSize: 20 }}>Willkommen, {me?.user.display_name}</h1>
        <p style={{ margin: 0, color: 'var(--ink-2)' }}>
          Dein Konto ist angelegt, hat aber noch keine Rolle. Die Administration schaltet dich frei.
        </p>
        <button className="btn" type="button" onClick={logout}>
          Abmelden
        </button>
      </div>
    </div>
  );
}
